<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Socios para crecer</template>
                    <template slot="en">Partners for growth</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <p class="text text-primary">
                <text-lang :lang="lang">
                    <template slot="es">El acceso al capital a través de Inversiones CrecePymes no es opcional, es una herramienta estratégicamente clave para crecer y para enfrentarse a otros competidores que tienen acceso al mercado de valores</template>
                    <template slot="en">Access to capital through CrecePymes is not optional. It is a necessary valuable strategic tool designed to make companies grow, allowing them to compete with the bigger competitors having access to stock and capital markets</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Los empresarios disponen de capital y cuentan con las mismas herramientas de crecimiento de las grandes empresas.</template>
                    <template slot="en">Shareholders have access to capital and same growth tools as big corporations.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Administran más patrimonio y lograrían operaciones de mayor productividad al aliarse a Inversiones CrecePymes.</template>
                    <template slot="en">Shareholders manage more equity and achieve larger operations when partnering with CrecePymes.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Facilitamos la distribución del riesgo y la liquidez patrimonial para los empresarios.</template>
                    <template slot="en">We ease risk distribution and equity liquidity to shareholders.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Incentivos fiscales.</template>
                    <template slot="en">Tax incentives.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Reducción de costos financieros. Financiamiento a muy largo plazo.</template>
                    <template slot="en">Reduction in financial costs. Long term financing.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Aportamos, además de capital, experiencia gerencial y relaciones que agregan valor estratégico a las empresas.</template>
                    <template slot="en">We provide (aside from the capital) broad corporate management experience and tools adding strategic value to companies. </template>
                </text-lang>
            </p>
            <p class="text text-secondary" style="margin-bottom:0px!important">
                <text-lang :lang="lang">
                    <template slot="es">Creamos estructuras de financiamiento que permiten superar los distintos ciclos económicos de las empresas.</template>
                    <template slot="en">We create financing strategies allowing companies to mitigate and overcome adverse economic cycles.</template>
                </text-lang>
            </p>          
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import TextLang from '@/components/TextLang.vue'

export default {
    name: 'PartnersForGrowth',
    props: ['lang'],
    components: {
        Parallax,
        TextLang
    }
}
</script>
